import {putMethod} from '~/api'

async function put(request) {
    return await putMethod('/api/seatsByProcessId', request)
}

export {put}
